
import { defineComponent } from 'vue';
import Credits from './components/Credits.vue';

export default defineComponent({
  name: 'App',
  components: {
    Credits,
  },
});
